/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import React from 'react';
import { Flex, Text, Button, VStack, Heading } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Flex minH="100vh" bg="bg.canvas" align="center" justify="center">
      <VStack gap={4} textAlign="center">
        <Text fontSize="5xl">🔒</Text>
        <Heading size="lg" color="fg.title">
          Access Denied
        </Heading>
        <Text color="fg.muted" maxW="360px">
          You don't have permission to view this page. Contact your administrator to request access.
        </Text>
        <Button bg="accent.solid" color="white" _hover={{ bg: 'accent.ink' }} onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </Button>
      </VStack>
    </Flex>
  );
};
